"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamOwnerById = exports.getTeamOwners = exports.getTeamOwnersMap = exports.getTeamOwnersIds = exports.getFetchedTeamId = exports.getIsTeamOwnersIdle = exports.getIsTeamOwnersLoaded = exports.getIsTeamOwnersLoading = exports.getTeamOwnersStatus = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _teamOwners = require("./teamOwners.reducer");

var getTeamOwnersState = function getTeamOwnersState(state) {
  return state.modules.campaignSettings.entities.teamOwners;
};

var selectors = _teamOwners.teamOwnersAdapter.getSelectors(getTeamOwnersState);

var getTeamOwnersStatus = (0, _ramda.pipe)(getTeamOwnersState, (0, _ramda.prop)('status'));
exports.getTeamOwnersStatus = getTeamOwnersStatus;
var getIsTeamOwnersLoading = (0, _ramda.pipe)(getTeamOwnersState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsTeamOwnersLoading = getIsTeamOwnersLoading;
var getIsTeamOwnersLoaded = (0, _ramda.pipe)(getTeamOwnersState, function (state) {
  return state.status === _utils.StateStatus.Fulfilled;
});
exports.getIsTeamOwnersLoaded = getIsTeamOwnersLoaded;
var getIsTeamOwnersIdle = (0, _ramda.pipe)(getTeamOwnersState, function (state) {
  return state.status === _utils.StateStatus.Idle;
});
exports.getIsTeamOwnersIdle = getIsTeamOwnersIdle;
var getFetchedTeamId = (0, _ramda.pipe)(getTeamOwnersState, (0, _ramda.prop)('teamId'));
exports.getFetchedTeamId = getFetchedTeamId;
var getTeamOwnersIds = selectors.getIds;
exports.getTeamOwnersIds = getTeamOwnersIds;
var getTeamOwnersMap = selectors.getEntities;
exports.getTeamOwnersMap = getTeamOwnersMap;
var getTeamOwners = selectors.getAll;
exports.getTeamOwners = getTeamOwners;
var getTeamOwnerById = selectors.getById;
exports.getTeamOwnerById = getTeamOwnerById;